'use client';

import { useMemo } from 'react';
import type { ReportCheckoutButtonProps } from '@timeblock/assessment-content/paid-reports';
import { useReportCheckout } from './use-report-checkout';
import { ReportCheckoutModal } from './ReportCheckoutModal';

/**
 * The result page's buy button: opens the report checkout in place instead of
 * sending the buyer to the separate report-offer page.
 */
export function ReportCheckoutButton({ runId, email, assessmentType, ctaLocation, className, children }: ReportCheckoutButtonProps) {
  const trackingProperties = useMemo(() => ({ cta_location: ctaLocation }), [ctaLocation]);
  const {
    startCheckout,
    refreshCheckout,
    closeCheckout,
    clientSecret,
    isLoading,
    error,
    priceUsd,
  } = useReportCheckout({
    runId,
    assessmentType,
    customerEmail: email ?? null,
    trackingProperties,
  });

  return (
    <>
      <button type="button" onClick={startCheckout} disabled={isLoading} className={className}>
        {isLoading ? 'Opening checkout...' : children}
      </button>
      {error && (
        <p className="text-sm text-red-700 mt-3 text-center" role="alert">
          {error}
        </p>
      )}
      <ReportCheckoutModal
        clientSecret={clientSecret}
        priceUsd={priceUsd}
        onClose={closeCheckout}
        refreshClientSecret={refreshCheckout}
      />
    </>
  );
}
